import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["displayName", "hubSpotUserEmail", "size"];
import { Component } from 'react';
import { DEFAULT_PROPS, GATES } from './Constants';
import { AvatarDisplay } from './AvatarDisplay';
import { getUnauthedHubSpotUserAvatarUrl } from './lib/getUnauthedHubSpotUserAvatarUrl';
import { isUngatedFor } from './api/gates';
import { jsx as _jsx } from "react/jsx-runtime";
export class UnauthedHubSpotUserAvatar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgSrc: undefined
    };
  }
  componentDidMount() {
    if (!this.props.hubSpotUserEmail) {
      return;
    }
    const isUngatedForTrellisIcons = isUngatedFor(GATES.TRELLIS_AVATAR_ICONS_GATE);
    const imageURI = getUnauthedHubSpotUserAvatarUrl({
      hubSpotUserEmail: this.props.hubSpotUserEmail,
      size: this.props.size,
      isUngatedForTrellisIcons
    });
    return this.setState({
      imgSrc: imageURI
    });
  }
  render() {
    const _this$props = this.props,
      {
        displayName,
        hubSpotUserEmail,
        size
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(AvatarDisplay, Object.assign({
      size: size,
      displayName: displayName || hubSpotUserEmail,
      src: this.state.imgSrc,
      type: "contact"
    }, rest));
  }
}
UnauthedHubSpotUserAvatar.defaultProps = {
  size: DEFAULT_PROPS.size
};